const host = window.env.REACT_APP_MYLIST_API_HOST || 'http://localhost:8085';

const api = (method, url, body, auth = true) => {
    const options = {
        method: method,
        headers: {
            'Content-Type': 'application/json',
        }
    }
    if (auth) {
        const token = JSON.parse(window.localStorage.getItem('token'));
        if (token) {
            options.headers.Authorization = `Bearer ${token}`;
        }
    }
    if (body) {
        options.body = body;
    }
    return fetch(((typeof url) === "object" ? url : ((new URL(`${host}${url}`)))).toString(), options);
}

const api3 = async ({
    method = 'GET',
    url,
    body,
    auth = true,
    refreshToken = true,
    rethrowOnRefreshError = false,
    extraOptionals = {},
    extraHeaders = {},

} = {}) => {
    return api2(method, url, body, auth, refreshToken, extraOptionals, extraHeaders, rethrowOnRefreshError);
}

const api2 = async (method, url, body, auth = true, refreshToken = true, extraOptionals = {}, extraHeaders = {}, rethrowOnRefreshError = false) => {
    const options = {
        method: method,
        headers: {
            'Content-Type': 'application/json',
            'X-Device-ID': window.localStorage.getItem('device_id'),
            ...extraHeaders,
        },
        ...extraOptionals,
    };
    if (auth) {
        const token = JSON.parse(window.localStorage.getItem('token'));
        if (token) {
            options.headers.Authorization = `Bearer ${token}`;
        }
    }
    if (body) {
        options.body = body;
    }
    const theUrl = ((typeof url) === "object" ? url : ((new URL(`${host}${url}`)))).toString();
    return fetch(theUrl, options)
        .then(async response => {
            if (response.ok) {
                return response.json();
            }
            if (response.status === 401 && refreshToken) {
                try {
                    const jwtToken = await MyListApi.refresh()
                    window.localStorage.setItem('token', JSON.stringify(jwtToken.token));
                    return api2(method, url, body, auth, false, extraOptionals);
                } catch (error) {
                    if (rethrowOnRefreshError) {
                        throw error;
                    } else {
                        window.location.href = '/login';
                        window.localStorage.setItem('user', JSON.stringify(null));
                        window.localStorage.setItem('token', JSON.stringify(null));
                    }
                    return;
                }
            }
            const text = await response.text();
            const data = text ? JSON.parse(text) : { message: `status ${response.status}` };
            throw new Error(data?.message || 'Invalid error response! Unknown error.');
        });
}

export const MyListApi = {

    login: async (username, password) => {
        const url = `/api/v1/login`;
        const body = JSON.stringify({
            username: username,
            password: password,
        });
        return api2('PUT', url, body, false, false, {
            credentials: 'include',
        });
    },

    auth: async (username, password) => {
        const url = `/api/v1/auth`;
        const body = JSON.stringify({
            username: username,
            password: password
        });
        return api2('POST', url, body, false, false, {
            credentials: 'include',
        });
    },

    authMe: async (token) => {
        const url = `/api/v1/auth/me`;
        return api('GET', url)
            .then(async response => {
                if (response.ok) return response.json();
                const data = await response.json();
                throw new Error(data.message);
            })
            .catch(error => {
                return Promise.reject(error);
            });
    },

    refresh: async () => {
        const url = `/api/v1/auth/refresh`;
        const extraOptionals = {
            credentials: 'include',
        };
        return api2('PUT', url, null, false, false, extraOptionals);
    },

    forgotPasswordRequest: async (email) => {
        const url = `/api/v1/change-password-request`;
        const body = JSON.stringify({
            username: email,
        });
        return api2('PUT', url, body);
    },

    changePassword: async (email, code, newPassword) => {
        const url = `/api/v1/change-password`;
        const body = JSON.stringify({
            email: email,
            code: code,
            password: newPassword,
        });
        return api2('PUT', url, body);
    },

    getItems3: async ({
        userId = null,
        tag = null,
        name = null,
        sort = ['createdAt', 'DESC'],
        isPopular = false,
        page = 0,
        perPage = 10,
    } = {}) => {
        const url = new URL(`${host}/api/v1/items`);
        const filter = {};

        if (userId) filter.user_id = userId;
        if (tag) filter.tag = tag;
        if (name) filter.name = name;

        url.searchParams.set('filter', JSON.stringify(filter));
        url.searchParams.set('page', page);
        url.searchParams.set('per_page', perPage);

        url.searchParams.set('is_popular', isPopular);
        if (sort) url.searchParams.set('sort', JSON.stringify(sort));

        return api2('GET', url);
    },

    getItems: async (userId, tag = null, name = null, sort = ['createdAt', 'DESC'], isPopular = false, page = 0, perPage = 10) => {
        const url = new URL(`${host}/api/v1/items`);
        const filter = {};

        if (userId) filter.user_id = userId;
        if (tag) filter.tag = tag;
        if (name) filter.name = name;

        url.searchParams.set('filter', JSON.stringify(filter));
        url.searchParams.set('page', page);
        url.searchParams.set('per_page', perPage);

        url.searchParams.set('is_popular', isPopular);
        if (sort) url.searchParams.set('sort', JSON.stringify(sort));

        return api2('GET', url);
    },

    getItems2: async (userId, filter = {}, sort = ['createdAt', 'DESC'], page = 0, perPage = 10) => {
        const url = new URL(`${host}/api/v1/items`);
        // const filter = {};

        // if (userId) filter.user_id = userId;
        // if (tag) filter.tag = tag;
        // if (name) filter.name = name;

        // url.searchParams.set('filter', JSON.stringify(filter));
        url.searchParams.set('page', page);
        url.searchParams.set('per_page', perPage);

        // if (isPopular) url.searchParams.set('is_popular', true);
        // if (sort) url.searchParams.set('sort', JSON.stringify(sort));

        return api('POST', url, JSON.stringify(filter))
            .then(async response => {
                if (response.ok) return response.json();
                const data = await response.json();
                throw new Error(data.error);
            })
            .then(data => Promise.resolve(data))
            .catch(error => Promise.reject(error));
    },

    itemSearch: async (tag, filters = {}) => {
        const url = new URL(`${host}/api/v1/items-search`);
        const body = {
            ...filters,
            'tag': tag,
        };
        return api2('POST', url, JSON.stringify(body), true, true);
    },

    // Body built by utils/browseSearch buildSearchBody: { tag, name?, [enumProperty]: [values] }.
    searchItems: async body => {
        const url = new URL(`${host}/api/v1/items-search`);
        return api2('POST', url, JSON.stringify(body), true, true);
    },

    getItem: async itemId => {
        return api2('GET', `/api/v1/items/${itemId}`);
    },

    popularItems: async (tagName, page = 0, perPage = 10) => {
        const url = new URL(`${host}/api/v1/popular-items`);
        url.searchParams.set('page', 0);
        url.searchParams.set('per_page', perPage);
        if (tagName) url.searchParams.set('tag_name', tagName);
        return api2('GET', url);
    },

    getTags: async (page = 0, perPage = 99) => {
        const url = new URL(`${host}/api/v2/tags`);

        url.searchParams.set('page', page);
        url.searchParams.set('per_page', perPage);

        return api2('GET', url, null, false);
    },

    getTag: async name => {
        return api2('GET', `/api/v1/tags/${name}`);
    },

    collectItem: async (itemId, action, onDate, imageFilename) => {
        const url = `/api/v1/collect-item/${itemId}`;
        const body = {
            action: action,
            onDate: onDate,
            imageFilename: imageFilename,
        };
        return api2('PUT', url, JSON.stringify(body));
    },

    createItem: async (tagId, name, data = {}) => {
        const url = `/api/v1/create-items`;
        const body = JSON.stringify({
            tag: { id: tagId },
            name: name,
            data: JSON.stringify(data),
        });
        return api2('POST', url, body);
    },

    createItem2: async (tagId, name, data = {}, itemLinks) => {
        const url = `/api/v2/create-items`;
        const body = JSON.stringify({
            tag: tagId,
            name: name,
            data: JSON.stringify(data),
            itemLinks: itemLinks,
        });
        return api2('POST', url, body);
    },

    createComment: async (comment, entityType, entityId) => {
        const url = `/api/v1/comments`;
        const body = JSON.stringify({
            entityType: entityType,
            entityId: entityId,
            text: comment,
        });
        return api2('POST', url, body)
    },

    getComments: async (entityType, entityId, page = 0) => {
        const url = new URL(`${host}/api/v1/comments`);

        url.searchParams.set('entity_type', entityType);
        url.searchParams.set('entity_id', entityId);
        url.searchParams.set('page', page);

        return api2('GET', url);
    },

    likeItem: async itemId => {
        return api2('PUT', `/api/v1/likes/${itemId}`);
    },

    unlikeItem: async itemId => {
        return api2('DELETE', `/api/v1/likes/${itemId}`);
    },

    isItemLiked: async (userId, itemId) => {
        const url = new URL(`${host}/api/v1/likes/${itemId}`);
        const options = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'user_id': userId,
            },
        };
        return fetch(url.toString(), options)
            .then(response => Promise.resolve(response.json()))
            .catch(error => Promise.reject(error));
    },

    signUp: async (name, email, password, referralCode) => {
        const url = new URL(`${host}/api/v1/signup`);
        const body = {
            name: name,
            email: email,
            password: password,
            referralCode: referralCode,
        }
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        }
        return fetch(url.toString(), options)
            .then(async response => {
                if (response.ok) {
                    return response.json();
                }
                const data = await response.json();
                throw new Error(data.message);
            })
            .catch(error => {
                return Promise.reject(error)
            });
    },

    userValidation: async (email, validationCode) => {
        const url = new URL(`${host}/api/v1/validation-code`);
        const body = {
            userEmail: email,
            validationCode: validationCode,
        };
        return api('PUT', url, JSON.stringify(body))
            .then(async response => {
                if (response.ok) return response.json();
                const data = await response.json();
                throw new Error(data.message);
            })
            .catch(error => {
                return Promise.reject(error);
            })
    },

    newUserValidation: async email => {
        const url = new URL(`${host}/api/v1/validation-code`);
        const body = {
            email: email
        };
        return api('POST', url, JSON.stringify(body))
            .then(async response => {
                if (response.ok) return true;
                const data = await response.json();
                throw new Error(data.message);
            })
            .catch(error => {
                return Promise.reject(error);
            })
    },

    getFriends: async (userId, page = 0, perPage = 100) => {
        const url = new URL(`${host}/api/v1/friends`);
        url.searchParams.set('page', page);
        url.searchParams.set('per_page', perPage);
        return api2('GET', url);
    },

    getPendingFriendRequests: async (userId) => {
        const url = new URL(`${host}/api/v1/friend-requests`);
        const options = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'user_id': userId,
            },
        };
        return fetch(url.toString(), options)
            .then(response => {
                return response.json();
            })
            .then(data => {
                return Promise.resolve(data);
            })
            .catch(error => {
                return Promise.reject(error);
            });
    },

    requestFriend: async (username) => {
        const url = `/api/v1/friends/${username}`;
        return api('POST', url)
            .then(async response => {
                if (response.ok) return response.json();
                const data = await response.json();
                throw new Error(data.data);
            })
            .then(data => {
                return Promise.resolve(data);
            })
            .catch(error => {
                return Promise.reject(error);
            });
    },

    acceptFriendRequest: async (friendId) => {
        const url = `/api/v1/friends/${friendId}`;
        return api('PUT', url)
            .then(async response => {
                if (response.ok) return response.json();
                const data = await response.json();
                throw new Error(data.data);
            })
            .then(data => {
                return Promise.resolve(data);
            })
            .catch(error => {
                return Promise.reject(error);
            });
    },

    getUser: async (userId) => {
        const url = `/api/v1/users/${userId}`;
        return api2('GET', url);
    },

    getActivities: async (page, perPage = 10, userId = null) => {
        const url = new URL(`${host}/api/v2/activities`);
        url.searchParams.set('page', page);
        url.searchParams.set('per_page', perPage);
        if (userId) url.searchParams.set('user_id', userId);
        // return api2('GET', url);
        return api3({ url: url, rethrowOnRefreshError: true })
    },

    createItemUpdate: async (itemId, property, value, action, type = null, validValues = null) => {
        const url = `/api/v1/item-updates`;
        const body = {
            item_id: itemId,
            property: property,
            value: value,
            action: action,
        }
        if (type) body['type'] = type;
        if (validValues) body['valid_values'] = validValues;
        return api('POST', url, JSON.stringify(body))
            .then(async response => {
                if (response.ok) return response.json();
                const data = await response.json();
                throw new Error(data.error);
            })
            .then(data => Promise.resolve(data))
            .catch(error => Promise.reject(error));
    },

    itemUpdateVote: async (itemUpdateId, apply) => {
        const url = new URL(`${host}/api/v1/item-updates/${itemUpdateId}/vote`);
        url.searchParams.set('apply', apply);
        return api('POST', url)
            .then(async response => {
                if (response.ok) return response.json();
                const data = await response.json();
                throw new Error(data.error);
            })
            .then(data => Promise.resolve(data))
            .catch(error => Promise.reject(error));
    },

    itemUpdateApply: async (itemUpdateId, apply) => {
        const url = `/api/v1/item-updates/${itemUpdateId}/${apply ? 'apply' : 'reject'}`;
        return api('PUT', url)
            .then(async response => {
                if (response.ok) return response.json();
                const data = await response.json();
                throw new Error(data.error);
            })
            .then(data => Promise.resolve(data))
            .catch(error => Promise.reject(error));
    },

    fetchPendingItems: async (page, pageSize) => {
        // const url = new URL(`${host}/api/v1/item-updates`);
        // url.searchParams.set('page', page);
        // url.searchParams.set('pageSize', pageSize);
        const url = new URL(`${host}/api/v1/admin/items-pending`);
        url.searchParams.set('page', page);
        url.searchParams.set('page_size', pageSize);
        return api2('GET', url);
    },

    approveItem: async (itemId) => {
        const url = `/api/v1/admin/approve-item/${itemId}`;
        return api('PUT', url)
            .then(async response => {
                if (response.ok) return response.json();
                const data = await response.json();
                throw new Error(data.error);
            })
            .then(data => Promise.resolve(data.data))
            .catch(error => Promise.reject(error));
    },

    rejectItem: async itemId => {
        const url = `/api/v1/admin/reject-item/${itemId}`;
        return api('PUT', url)
            .then(async response => {
                if (response.ok) return response.json();
                const data = await response.json();
                throw new Error(data.error);
            })
            .then(data => Promise.resolve(data.data))
            .catch(error => Promise.reject(error));
    },

    getAdminStats: async () => {
        const url = `/api/v1/admin/stats`;
        return api('GET', url)
            .then(async response => {
                if (response.ok) return response.json();
                const data = await response.json();
                throw new Error(data.error);
            })
            .then(data => Promise.resolve(data.data))
            .catch(error => Promise.reject(error));
    },

    getOngoingActions: async (userId, page = 0, perPage = 20) => {
        const url = new URL(`${host}/api/v1/users/${userId}/ongoing-actions`);
        url.searchParams.set('page', page);
        url.searchParams.set('per_page', perPage);
        return api3({
            url: url,
            rethrowOnRefreshError: true,
        });
    },

    getUserStats: async (userId) => {
        const url = `/api/v1/users/${userId}/stats`;
        return api3({
            url: url,
            rethrowOnRefreshError: true,
        });
    },

    uploadImage: async (file, onProgress = () => {}) => {
        return new Promise((resolve, reject) => {
            const token = JSON.parse(window.localStorage.getItem('token'));
            const url = `/api/v1/images`;
            const formData = new FormData();
            formData.append('file', file);

            const xhr = new XMLHttpRequest();
            xhr.open('POST', url);
            xhr.setRequestHeader('Authorization', `Bearer ${token}`);

            xhr.upload.onprogress = e => {
                if (onProgress) {
                    const pct = e.lengthComputable ? Math.round((e.loaded / e.total) * 100) : null;
                    onProgress(pct, e);
                }
            };

            xhr.onload = () => {
                const ok = xhr.status >= 200 && xhr.status < 300;
                try {
                    const data = xhr.responseText ? JSON.parse(xhr.responseText) : {};
                    ok ? resolve(data) : reject(new Error(data?.message || `status ${xhr.status}`));
                } catch {
                    ok ? resolve({}) : reject(new Error(`status ${xhr.status}`));
                }
            };

            xhr.onerror = () => reject(new Error('Network error.'));
            xhr.onabort = () => reject(new Error('Upload aborted.'));

            xhr.send(formData);
        });
    },

    uploadProfileImage: async file => {
        const token = JSON.parse(window.localStorage.getItem('token'));
        const formData = new FormData();
        formData.append("file", file);
        const url = `/api/v1/profile-images`;
        const options = {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
            body: formData,
        }
        return fetch(new URL(`${host}${url}`).toString(), options)
            .then(async response => {
                if (response.ok) return response.json();
                const data = await response.json()
                throw new Error(data.error);
            })
    },

    getItemUpdate: async itemUpdateId => {
        const url = `/api/v1/item-updates/${itemUpdateId}`;
        return api('GET', url)
            .then(async response => {
                if (response.ok) return response.json();
                const data = await response.json();
                throw new Error(data.error);
            })
            .then(data => Promise.resolve(data))
            .catch(error => Promise.reject(error));
    },

    updateUser: async user => {
        const url = `/api/v1/users`;
        const body = JSON.stringify(user);
        return api2('PUT', url, body);
    },

    getItemUpdates: async (page, pageSize) => {
        const url = new URL(`${host}/api/v1/item-updates`);
        url.searchParams.set('page', page);
        url.searchParams.set('pageSize', pageSize);
        return api2('GET', url);
    },
}
